import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

// Game-style "back" control: a breadcrumb link plus ESC to return one level.
export default function MenuBack({ to = "/home", label = "Main Menu", trail }) {
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "Escape" || e.defaultPrevented) return;
      // Don't throw away a half-filled form or fight an open menu/dialog.
      if (e.target?.closest?.("form, [role='dialog'], [data-testid='mobile-menu']")) return;
      const tag = e.target?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return;
      if (e.target?.isContentEditable) return;
      navigate(to);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate, to]);

  return (
    <div className="px-5 md:px-12 py-4 flex items-center justify-between gap-4 border-b border-[#1F2330] bg-[#06080C] text-[10px] font-mono uppercase tracking-[0.3em]">
      <Link
        data-testid="menu-back"
        to={to}
        className="inline-flex items-center gap-1 text-[#A0A6B5] hover:text-white outline-none focus-visible:ring-1 focus-visible:ring-[#D4AF37]"
      >
        <ChevronLeft className="w-3 h-3" /> {label}
      </Link>
      <div className="flex items-center gap-3 text-[#8A91A0]">
        {trail && <span className="hidden sm:inline">{trail}</span>}
        <span className="hidden md:inline border border-[#2A3040] px-1.5 py-0.5">ESC</span>
        <span className="hidden md:inline">Back</span>
      </div>
    </div>
  );
}
